<template>
  <section>
    <gs-header title="Quản lý permissions">
      <router-link :to="{name: 'create-permission'}" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table
        :ref="permissionTable"
        :table-name="permissionTable"
        data-source="permissions"
        :data-params="filters"
        :data-sorted="sorted"
        :data-sorts="sorts"
        @remove-filter="removeFilter"
      >
        <section slot="filters">

        </section>
        <template slot-scope="datas">
          <el-table
            :data="datas.data"
            border
            style="width: 100%">
          >
            <el-table-column
                label="#"
                width="80"
              >
                <template slot-scope="scope">
                  <small v-if="dataPaginations[permissionTable]">{{(scope.$index + 1) + ((dataPaginations[permissionTable].current_page -1) * dataPaginations[permissionTable].per_page)}}</small>
                </template>
              </el-table-column>

            <el-table-column
              label="Tên"
              width="200"
            >
              <template slot-scope="scope">
                <p>{{scope.row.name}}</p>
              </template>
            </el-table-column>

            <el-table-column
              label="Tên hiển thị"
              width="200"
            >
              <template slot-scope="scope">
                <p>{{scope.row.display_name}}</p>
              </template>
            </el-table-column>

            <el-table-column
              label="Mô tả"
            >
              <template slot-scope="scope">
                <p>{{scope.row.description}}</p>
              </template>
            </el-table-column>

            <el-table-column
              label="Tạo lúc"
            >
              <template slot-scope="scope">
                <p>{{scope.row.created_at}}</p>
              </template>
            </el-table-column>

            <el-table-column
              width="95"
            >
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <!-- <el-tooltip placement="top" content="Chi tiết" class="display-inline">
                     <a @click.prevent="detailRole(scope.row)" class="text-blue padding-all display-inline-block cursor-pointer"><i class="fa fa-search"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Sửa" class="display-inline">
                    <router-link class="text-orange padding-all display-inline-block" :to="{name: 'edit-permission', params: {id: scope.row.id}}"><i class="fa fa-pencil-square-o"></i></router-link>
                  </el-tooltip> -->
                  <el-tooltip placement="top" content="Xóa" class="display-inline">
                     <a @click.prevent="deletePermission(scope.row)" class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
  </section>
</template>

<script>
import { debounce } from 'lodash'
import ls from 'local-storage'
import { deletePermission } from 'src/api/permissions'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Permission',
  data () {
    return {
      permissionTable: 'permissions',
      filters: {
        sort: 'created_at:-1'
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        {key: 'created_at', name: 'Ngày tạo'}
      ]
    }
  },
  computed: {
    ...mapGetters('permission', ['permission'])
  },
  methods: {
    ...mapActions('permission', ['setPermission']),
    removeFilter () {
      this.reloadGsTable(this.permissionTable)
      this.filters = {
        sort: 'created_at:-1'
      }
    },
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.permissionTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.permissionTable)
      }
    }, 300),
    deletePermission (permission) {
      this.setPermission(permission)
      this.$confirm(`Bạn chắc chắn muốn xóa permission ${this.permission.name}`, 'Xóa permission', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delPermission()
      }).catch(() => {

      })
    },
    delPermission () {
      deletePermission(this.permission.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa permission thành công'
          })
          this.reloadGsTable(this.permissionTable)
        } else {
          this.$message({
            type: 'danger',
            message: 'Xóa permission thất bại'
          })
        }
      })
    }
  },
  mounted () {
    if (ls.get('filters') && ls.get('filters')[this.permissionTable]) {
      this.filters = ls.get('filters')[this.permissionTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.permissionTable)
  },
  beforeRouteEnter (to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['permissions']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Permission.vue?21f7a951